import { Menu as MuiMenu, MenuItem, Typography } from '@mui/material';
import React, { memo, useCallback } from 'react';

import { FilterOption } from '~/pages/ExternalUsers';

interface Props {
  anchorEl: HTMLElement | null;
  filterOptions: FilterOption[];
  getFilterOptionName: (option: FilterOption) => string;
  onClose: (event: React.MouseEvent<HTMLButtonElement | HTMLLIElement>) => void;
  onSelect: (filterOption: FilterOption) => void;
}

const Component: React.FC<Props> = ({
  anchorEl,
  filterOptions,
  getFilterOptionName,
  onClose,
  onSelect,
}) => {
  const handleSelect = useCallback(
    (event: React.MouseEvent<HTMLLIElement>, filterOption: FilterOption) => {
      onSelect(filterOption);

      onClose(event);
    },
    [onClose, onSelect],
  );

  const getFilterOptionColor = useCallback((option: FilterOption) => {
    if (option === 'activated') {
      return 'var(--success-color)';
    }

    if (option === 'deactivated') {
      return 'var(--error-color)';
    }

    if (option === 'expired') {
      return 'var(--gray-2-color)';
    }

    if (option === 'submitted') {
      return 'var(--text-2-color)';
    }

    return 'var(--black-color)';
  }, []);

  return (
    <MuiMenu
      anchorEl={anchorEl}
      anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
      open={Boolean(anchorEl)}
      transformOrigin={{ horizontal: 'left', vertical: 'top' }}
      onClose={onClose}
    >
      {filterOptions.map(option => (
        <MenuItem
          key={option}
          sx={{ paddingTop: '16px', paddingBottom: '16px' }}
          onClick={event => handleSelect(event, option)}
        >
          <Typography color={getFilterOptionColor(option)} lineHeight="24px" variant="subtitle1">
            {getFilterOptionName(option)}
          </Typography>
        </MenuItem>
      ))}
    </MuiMenu>
  );
};

export const Menu = memo(Component);
